import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Input } from "reactstrap";
import "./CreateTournamentInput.css";

// TODO: Legacy file - needs full refactor to use categories instead of divisions/seasons
// import { updateDivision } from "../../redux/slices/tournamentSlice";
import { DASHBOARD_STACK } from "../../utils/screenNames";

const TeamCount = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // TODO: Legacy - selectedDivision removed, using selectedCategory
  const { selectedTournament, selectedCategory: selectedDivision } = useSelector(
    (state) => state.tournament
  );
  const [numberOfTeams, setNumberOfTeams] = useState(0);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (selectedTournament?.numberOfTeams) {
      setNumberOfTeams(selectedTournament.numberOfTeams || 0);
    }
  }, [selectedTournament]);

  const validateInput = () => {
    const newErrors = {};
    if (numberOfTeams <= 0) {
      newErrors.numberOfTeams = "Number of teams must be greater than 0";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    try {
      if (!validateInput()) {
        return;
      }

      if (selectedTournament?.id && selectedDivision?._id) {
        // TODO: Legacy - updateDivision thunk removed
        // const result = await dispatch(
        //   updateDivision({
        //     tournamentId: selectedTournament.id,
        //     divisionId: selectedDivision._id,
        //     divisionData: {
        //       numberOfTeams: numberOfTeams,
        //     },
        //   })
        // );
        //
        // if (result.meta.requestStatus === "fulfilled") {
        //   toast.success("Number of teams updated successfully!");
        //   navigate(DASHBOARD_STACK.CREATE_TOURNAMENT.CREATE_TOURNAMENT_GROUPS);
        // } else {
        //   throw new Error("Failed to update number of teams");
        // }
      }
    } catch (error) {
      toast.error(error.message || "Failed to update number of teams");
    }
  };

  return (
    <>
      <div className="input-section">
        <p>Enter Number of Teams</p>
        <Input
          type="number"
          value={numberOfTeams}
          onChange={(e) => setNumberOfTeams(parseInt(e.target.value))}
          placeholder="10"
          className="tournament-input"
          min="1"
          onWheel={(e) => e.target.blur()}
        />
        {errors.numberOfTeams && (
          <div className="error-message">{errors.numberOfTeams}</div>
        )}
      </div>

      <Button className="next-button" onClick={handleNext}>
        Next
      </Button>
    </>
  );
};

export default TeamCount;
